<template>
  <a-modal
    :title="title"
    :visible="visible.loadingModal"
    destroyOnClose 
    :maskClosable="false"
    width="550px"
    :footer='false'
    :closable='false'
  >
    <a-progress :percent="percent" />
    <p>正在加载配方数据</p>
  </a-modal>
</template>
<script>
import { nhfMixins } from '../../untils'
export default {
  mixins: [nhfMixins],
  data(){
    return {
      title: <p>配方设计页初始化</p>,
      percent: 0,
      timer: null
    }
  },
  mounted(){
    this.timer = setInterval(() => {
      if(this.percent < 100){
        this.percent += 20
      }
    }, 800);
  },
  watch:{
    'visible.loadingModal': {
      handler(val){
        if(val) this.percent = 0
      },
      deep: true
    },
    percent(val){
      if(val === 100){
        this.timer = null
      }
    },
  }
}
</script>